import React from 'react';
import styled from 'styled-components';
import Icon from '../../containers/assets/success-icon.png';

const AlertWrapper = styled.div`
  background: #eaf3ec;
  color: #222;
  border: 1px solid #2da548;
  border-radius: 4px;
  margin-top: 20px;
  width: 100%;
  max-width: 800px;
  padding: 9px 16px;

  font-family: 'Mukta Vaani';
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 27, 59, 0.94);

  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: flex-start;

  ${p => p.marginTop && `
    margin-top: ${p.marginTop}px;
  `}

  ${p => p.marginBottom && `
    margin-bottom: ${p.marginBottom}px;
  `}
`;

const SuccessAlert = ({ message, marginTop, marginBottom }) => (
  <AlertWrapper marginTop={marginTop} marginBottom={marginBottom}>
    <div><img src={Icon} alt="" /></div>
    <div>{message}</div>
  </AlertWrapper>
);

export default SuccessAlert;



// WEBPACK FOOTER //
// ./src/components/alerts/success.js